// Consent Complete Page - Stage 05 - VISUALLY UPDATED with InsureVision Colors
// UPDATED: Added demo mode support - skip auto-redirect
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useOnboarding } from '../../context/OnboardingContext'
import { useDemoMode } from '../../hooks/useDemoMode'

const ConsentCompletePage = () => {
  const navigate = useNavigate()
  const { transitionToStage, STAGES } = useOnboarding()
  const { isDemoMode, exitDemo } = useDemoMode()

  useEffect(() => {
    // DEMO MODE: Skip auto-redirect
    if (isDemoMode) return

    // Auto-advance to API setup after a brief pause
    // Use hard navigation to ensure fresh state fetch from Airtable
    const timer = setTimeout(() => {
      window.location.href = '/onboarding/api-setup'
    }, 2000)

    return () => clearTimeout(timer)
  }, [isDemoMode])

  return (
    <div className="max-w-xl mx-auto text-center animate-fade-in">
      <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-gradient-to-br from-accent-500 to-accent-600 flex items-center justify-center shadow-strong">
        <svg className="w-8 h-8 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
        </svg>
      </div>
      <h1 className="text-2xl font-display font-bold text-brand-950 mb-3">
        Agreement Confirmed
      </h1>
      <p className="text-slate-600 mb-6">
        Thank you! Your Data Access Agreement has been recorded. Now let's connect 
        your dashcam provider account so we can analyze your fleet footage.
      </p>
      {/* Demo mode: Manual continue button */}
      {isDemoMode ? (
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <button
            onClick={() => {
              transitionToStage(STAGES.API_SETUP)
              navigate('/onboarding/api-setup')
            }}
            className="btn-accent px-6 py-3"
          >
            Continue to API Setup
          </button>
          <button
            onClick={exitDemo}
            className="btn-secondary px-6 py-3"
          >
            Exit Demo
          </button>
        </div>
      ) : (
        <div className="flex items-center justify-center gap-2 text-sm text-slate-500">
          <svg className="animate-spin h-4 w-4 text-accent-600" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z" />
          </svg>
          Redirecting to API setup...
        </div>
      )}
    </div>
  )
}

export default ConsentCompletePage
